// extracted by mini-css-extract-plugin
module.exports = {"vGutterX":"30px","vRed1":"#f42c69","block":"StoreBannerGift_block__3e1-I","icon":"StoreBannerGift_icon__3iJVG","text":"StoreBannerGift_text__3-inm"};